module.exports = __webpack_public_path__ + "static/media/04.b1f51f6c.webp";